import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { AmountDiscount, DepositIntent, DiscountType, FractionDiscount, } from '@debbie/common/dist/intents/index.js';
import { Input, Select } from '../../index.js';
import MoneyInput from '../../MoneyInput.js';
const DepositCreator = (props) => {
    const [days, setDays] = useState(10);
    const [discountType, setDiscountType] = useState();
    const [discountAmount, setDiscountAmount] = useState(NaN);
    const [discountPercent, setDiscountPercent] = useState(NaN);
    const lang = useSelector((s) => s.lang);
    const onEdit = () => {
        const discount = discountType === DiscountType.Amount
            ? AmountDiscount(discountAmount)
            : discountType === DiscountType.Fraction
                ? FractionDiscount(discountPercent * 0.01)
                : undefined;
        const intent = DepositIntent(days, discount);
        props.onEdit(intent);
    };
    useEffect(() => {
        onEdit();
    }, [days, discountType, discountAmount, discountPercent]);
    return (React.createElement("div", null,
        React.createElement(Input, { value: days, type: "number", placeholder: lang.intents.days, step: 1, min: 0, onChange: (e) => {
                setDays(parseInt(e.target.value));
            } }),
        React.createElement(Select, { onChange: (e) => setDiscountType(e.target.value), value: discountType },
            React.createElement("option", null, lang.intents.noDiscount),
            React.createElement("option", { value: DiscountType.Amount }, lang.intentDiscountTypes[DiscountType.Amount]),
            React.createElement("option", { value: DiscountType.Fraction }, lang.intentDiscountTypes[DiscountType.Fraction])),
        discountType === DiscountType.Amount && (React.createElement(MoneyInput, { placeholder: lang.intentDiscountTypes[DiscountType.Amount], onChange: setDiscountAmount, value: discountAmount })),
        discountType === DiscountType.Fraction && (React.createElement(Input, { placeholder: lang.intents.percentDiscount, type: "number", min: "0", max: "100", step: "0.01", onChange: (e) => setDiscountPercent(parseFloat(e.target.value)), value: discountPercent }))));
};
export default DepositCreator;
//# sourceMappingURL=DepositCreator.js.map